module.exports = __webpack_public_path__ + "img/Stewardship-2022.cc0f175a.png";